/* eslint-disable react/require-default-props */
import * as React from "react";
import { Breadcrumb, type SemanticICONS } from "semantic-ui-react";

type ApplicationBreadcrumbSeparatorProps = {
	icon?: SemanticICONS;
};

const ApplicationBreadcrumbSeparator = ({
	icon = "arrow right",
}: ApplicationBreadcrumbSeparatorProps) => <Breadcrumb.Divider icon={icon} />;

export default ApplicationBreadcrumbSeparator;
